import { useState } from 'react';
import DebatePage from './components/DebatePage';
import { Candidate } from './types';
import CandidateSelector from './components/CandidateSelector';
import CoffeeButton from './components/CoffeeButton';

function App() {
  const [currPage, setCurrPage] = useState<"candidate" | "debate">("candidate");
  const [selectedCandidates, setSelectedCandidates] = useState<Candidate[]>([]);

  const startDebate = (candidates: Candidate[]) => {
    setSelectedCandidates(candidates);
    setCurrPage("debate");
  }

  if (currPage === "debate" && selectedCandidates.length === 2) {
    return (
      <>
        <div className="fixed bottom-72 md:bottom-4 right-0 md:right-4">
          <CoffeeButton />
        </div>
        <DebatePage debatingCandidates={selectedCandidates} backToSelect={() => setCurrPage("candidate")} />
      </>
    );
  }

  return (
    <>
      <div className="fixed bottom-72 md:bottom-4 right-0 md:right-4">
        <CoffeeButton />
      </div>
      <CandidateSelector startDebate={startDebate}/>
    </>
  );
}

export default App;

// Keep track of conversation in one list of messages. Each message is an object of speaker and message
// TODO: add option to continue conversation/ask follow up/prompt followup
    // will likely have to implement better response tracking first
// TODO: generate topics and questions based on the candidates that were selected (maybe)
    // TODO: create button to generate topics based on candidates
// HuggingFace API? or Azure OpenAI try to use latest model to have current events + free
  // Martian is also an option
// TODO: Different temperature each response? random temperature

// TODO: Share conversation
  // Need to figure out best way to share conversation

// BUG: firefox shows buttons at width-fit

// COMPLETE: add option to create your own candidate
// COMPLETE: automatic followup (100% if first response given)
// COMPLETE: mobile styles
// COMPLETE: move api key to .env
// COMPLETE: Google Analytics
// COMPLETE: Microsoft Clarity
// COMPLETE: coffee button
// COMPLETE: add ability to hear rebuttal even when AI doesn't detect